
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M229 44.6C155.3 55.3 93.9 107.9 72.4 178.8c-6 19.9-7.7 31.9-7.8 54.7 0 21.3.9 28.8 5.9 47.3 14.8 55.2 59.8 113.3 126.6 163.7 33.8 25.5 42.1 29.2 62.4 28.3 7.5-.4 11.7-1.2 16.8-3.1 8.1-3.1 26-15.1 45.7-30.6 89.3-70.2 132.4-146.6 125.1-221.6-4.4-45.1-22.1-83.8-53.1-115.9-30.5-31.6-68.5-51-111.9-57-13.7-1.9-39.8-1.9-53.1 0m42.4 114.9c18.5 3.9 36.9 18.4 45.4 35.6 9.7 19.6 9.7 41.2 0 60.8-6 12.3-17.9 24.2-30 30-19.7 9.5-40.9 9.5-60.6 0-12.1-5.8-24-17.7-30-30-9.7-19.6-9.7-41.2 0-60.8 6-12.1 17.8-24 29.9-29.9 4.7-2.4 11.5-4.9 15-5.7 8.5-1.8 21.8-1.8 30.3 0"}})])
          )
        }
      }
    